import React, { useState } from 'react';
const faqs = [{
  question: '¿Cómo recibo el Megapack después de comprar?',
  answer: 'En el momento en que confirmás el pago recibís un mail con el acceso a todos los materiales. No hay espera, no hay envío físico. Todo es digital y lo podés abrir desde el celular, la tablet o la computadora en menos de 5 minutos.'
}, {
  question: '¿Sirve si trabajo sola en consultorio privado o solo para centros?',
  answer: 'Está pensado principalmente para terapeutas que trabajan solos o en consultorio pequeño. Todo el sistema está diseñado para que lo manejés vos sin depender de nadie más. Si trabajás en un centro también lo podés aplicar, pero el foco es la práctica autogestionada.'
}, {
  question: '¿Los materiales son editables?',
  answer: 'Sí. Los documentos vienen en formatos editables para que puedas poner tu nombre, logo y datos. Los checklists, protocolos y guiones son tuyos para personalizar como necesites.'
}, {
  question: '¿Los 6 bonos están incluidos en las dos opciones?',
  answer: 'Sí, los 6 bonos están incluidos en las dos opciones. Si querés el sistema completo con Consultorio Rentable™ — honorarios, límites y blindaje legal — esa es la opción más inteligente.'
}, {
  question: '¿Sirve si soy recién recibida con poca experiencia?',
  answer: 'Es ideal para eso. Todo está explicado con criterio clínico pero en lenguaje claro y aplicable desde el primer día. No asume que ya sabés todo — te da el marco para trabajar con seguridad aunque estés empezando.'
}, {
  question: '¿Funciona para distintas orientaciones teóricas?',
  answer: 'Sí. El sistema está diseñado sobre estructura clínica, no sobre una orientación específica. Podés aplicarlo seas cognitivo-conductual, psicoanalítica, sistémica o integrativa. El foco está en la intervención y el sostenimiento del proceso, no en la técnica.'
}, {
  question: '¿Qué pasa si tengo un paciente en crisis o con ideación?',
  answer: 'El Tomo 4 tiene protocolos paso a paso para crisis, ideación recurrente y desborde emocional. No reemplaza el juicio clínico, pero te da un marco estructurado para actuar con claridad en los momentos más exigentes.'
}, {
  question: '¿Qué diferencia tiene con otros materiales del mercado?',
  answer: 'La mayoría de los materiales que existen son teóricos o están pensados para la formación académica. Este sistema está diseñado para la práctica real: casos difíciles resueltos, protocolos de intervención, blindaje emocional y retención de pacientes. No es un libro — es una caja de herramientas lista para usar hoy.'
}, {
  question: '¿Por qué elegir Megapack + Consultorio Rentable™ y no el estándar?',
  answer: 'El Megapack te da el sistema clínico para resolver casos difíciles. Consultorio Rentable™ le agrega el sistema de gestión: cómo cobrar, cómo poner límites, blindaje legal y organización profesional. Si querés trabajar mejor, el Megapack alcanza. Si querés además ejercer con dignidad y cobrar lo que merecés, la segunda opción es la decisión obvia.'
}, {
  question: '¿Tiene garantía real?',
  answer: 'Sí. Tenés 7 días desde el momento de la compra para revisarlo todo. Si no es lo que esperabas te devolvemos el 100% del dinero sin preguntas, sin formularios y sin drama. La tasa de devolución es menor al 1% — no porque no se pueda pedir, sino porque el material habla por sí solo.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full px-4 lg:px-8 py-10 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(255,255,255) 0%, rgb(255,255,255) 15%, rgb(255,255,255) 85%, rgb(245,243,255) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-147">
      <div className="mx-auto max-w-3xl" data-id="element-148">
        <h2 className="text-3xl font-black text-center text-gray-900 m-0 mb-2" data-id="element-149">
          Preguntas <span className="text-violet-700" data-id="element-150">frecuentes</span>
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-8" data-id="element-151">
          Todo lo que necesitás saber antes de decidir.
        </p>

        <div className="flex flex-col gap-2" data-id="element-152">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          const panelId = `faq-panel-${i}`;
          const buttonId = `faq-button-${i}`;
          return <div key={i} className="bg-white rounded-xl overflow-hidden shadow-sm transition-all" style={{
            border: isOpen ? '1px solid rgba(109, 40, 217, 0.5)' : '1px solid rgba(109, 40, 217, 0.15)'
          }} data-id="element-153">
                <button id={buttonId} onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={panelId} className="flex w-full items-center justify-between gap-3 text-left bg-transparent cursor-pointer border-0 px-5 py-4 m-0" style={{
              fontFamily: 'inherit'
            }} data-id="element-154">
                  <span className="text-sm font-bold" style={{
                color: isOpen ? '#6d28d9' : '#111827'
              }} data-id="element-155">
                    {i + 1}. {faq.question}
                  </span>
                  <span className="shrink-0 w-6 h-6 rounded-full flex items-center justify-center text-white text-base font-black transition-transform duration-300" style={{
                backgroundColor: '#7c3aed',
                transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)'
              }} aria-hidden="true" data-id="element-156">
                    +
                  </span>
                </button>

                {isOpen && <div id={panelId} role="region" aria-labelledby={buttonId} className="px-5 pb-4" style={{
              borderTop: '1px solid rgba(109, 40, 217, 0.1)'
            }} data-id="element-157">
                    <p className="text-sm text-gray-600 leading-relaxed m-0 pt-3" data-id="element-158">
                      {faq.answer}
                    </p>
                  </div>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}